<script>
  import Hero from "$lib/components/Hero/Hero.svelte";
  import Icon from "$lib/components/Icon.svelte";
  import PageBody from "$lib/components/Page/PageBody.svelte";
  import TwoColumnLayout from "$lib/components/TwoColumnLayout.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import ItemPreviewList from "$lib/contentTypes/ItemPreviewList.svelte";
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";

  export let page;
</script>

<div class="w-full px-24 md:px-175 lg:max-w-1014 lg:px-0 m-auto" id="page-header">
  <Hero
    parentInfo={page.fields.pageData.fields.parentInfo}
    title={page.fields.pageData.fields.headline}
    pageRelativePathString={page.fields.relativePathString}
  />
</div>

<!-- featured result -->
{#if page.fields.featuredResult}
  <div
    data-headings-increment
    class="w-full bg-neutral-100 flex flex-col justify-center items-center px-72 page-level-padding pb-48 lg:pb-72"
  >
    <TwoColumnLayout columnLayout="rightWide">
      <div slot="left">
        <div class="heading-5">{page.fields.featuredResult.fields.headline}</div>
        <p class="pt-24 pb-40">{page.fields.featuredResult.fields.previewText || ""}</p>
        <LinkComponent
          data={{
            type: "ghostButton",
            destination: {
              fields: { url: "" }
            }
          }}
        >
          <span>Learn More</span>
          <Icon type="chevron-right" trailing />
        </LinkComponent>
      </div>
      <ImageComponent
        slot="right"
        data={page.fields.featuredResult.fields.previewImageComponent}
        displayCaption={false}
        containerized={true}
        lg={"800px"}
        responsive
      />
    </TwoColumnLayout>
  </div>
{/if}

<!-- item preview lists -->
<div class="internal-page-spacing">
  {#if page.fields.itemPreviewLists}
    {#each page.fields.itemPreviewLists as listData}
      <div class="w-full bg-gray-100 flex flex-col justify-center mb-4">
        <div class="m-auto">
          <ItemPreviewList data={listData} itemsPerPage={6} hideSectionHeader />
        </div>
      </div>
    {/each}
  {/if}
</div>

<div class="pt-48 lg:pt-72" data-headings-increment>
  <!-- trailing content -->
  {#if page.fields.trailingContent}
    <div class="w-full flex flex-col justify-center items-center">
      <div class="md:w-1/2 m-auto">
        <PageBody body={page.fields.trailingContent} />
      </div>
    </div>
  {/if}
</div>
